(function () {

  // =========================================================
  // ✅ NAME GATE ON / OFF SWITCH
  // false = Name Gate DISABLED
  // true  = Name Gate ENABLED
  // =========================================================
  var NAME_GATE_ENABLED = false;


  // ✅ Allowed names (add/remove as needed)
  var ALLOWED_NAMES = [
    "Jodi Kleyn",
    "Carlo",
    "Jodi",
    "Carlo Bellini",
    "Maghu",
    "George",
    "Husayn",
    "Paul",
    "Sham",
    "Elizabeth",
    "Edward",
    "David",
    "Angela",
    "Jennifer",
    "John",
    "Brandon",
    "Riteesh",
    "Nelson",
    "Chris",
    "Petra",
    "Christian",
    "Andrew",
    "Hafees",
  ];

  // ✅ Storage key for showing the name after entering
  var NAME_KEY = "nameGate_name_v1";

  // ✅ Brand name used in the banner message
  var BRAND_NAME = "Track Limits";

  function byId(id) {
    return document.getElementById(id);
  }

  function sanitizeName(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 40);
  }

  function normalize(v) {
    return String(v || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  }

  function forceTop() {
    try {
      window.scrollTo(0, 0);
    } catch (e) {}
  }

  function setHint(msg) {
    var hint = byId("nameGateHint");
    if (hint) hint.textContent = msg || "";
  }

  // ✅ Premium animated banner
  function showWelcomeBanner(name) {
    var banner = byId("nameGateWelcome");

    // Create banner if it doesn't exist
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "nameGateWelcome";
      banner.className = "name-gate-welcome";
      document.body.insertBefore(banner, document.body.firstChild);
    }

    // Build premium inner markup
    var safeName = String(name || "").trim();
    var message =
      safeName + ", unlock your adventure through " + BRAND_NAME + ".";

    banner.innerHTML =
      '<div class="name-gate-welcome__inner">' +
        '<span class="name-gate-welcome__badge">INVITED</span>' +
        '<div class="name-gate-welcome__text">' + message + '</div>' +
      '</div>';

    banner.hidden = false;

    // Trigger animation (slide/fade in)
    requestAnimationFrame(function () {
      banner.classList.add("is-show");
    });
  }

  function showGate() {
    var gate = byId("nameGate");
    if (!gate) return;

    forceTop();

    // Prevent Shopify preview hash jumps
    if (window.location.hash) {
      try {
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
      } catch (e) {}
    }

    gate.classList.add("is-visible");
    gate.setAttribute("aria-hidden", "false");

    setTimeout(function () {
      forceTop();
      var input = byId("nameGateInput");
      if (input) input.focus();
    }, 50);
  }

  function hideGate() {
    var gate = byId("nameGate");
    if (!gate) return;

    gate.classList.add("is-hiding");
    gate.classList.remove("is-visible");
    gate.setAttribute("aria-hidden", "true");

    setTimeout(function () {
      gate.style.display = "none";
    }, 520);
  }

  document.addEventListener("DOMContentLoaded", function () {

    // =========================================================
    // ✅ IF NAME GATE IS DISABLED, HIDE IT AND STOP HERE
    // =========================================================
    if (!NAME_GATE_ENABLED) {
      var disabledGate = byId("nameGate");

      if (disabledGate) {
        disabledGate.classList.remove("is-visible");
        disabledGate.setAttribute("aria-hidden", "true");
        disabledGate.style.display = "none";
      }

      return;
    }


    // =========================================================
    // NAME GATE CODE BELOW ONLY RUNS WHEN ENABLED
    // =========================================================

    var gate = byId("nameGate");
    var form = byId("nameGateForm");
    var input = byId("nameGateInput");

    if (!gate || !form || !input) return;

    // ✅ If they've already entered a name before,
    // show it on the site immediately
    try {
      var savedName = localStorage.getItem(NAME_KEY);

      if (savedName) {
        showWelcomeBanner(savedName);
      }
    } catch (e) {}

    // Always show on every visit
    showGate();

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var typed = sanitizeName(input.value);

      if (!typed) {
        setHint("Please enter your name.");
        input.focus();
        return;
      }

      var typedNorm = normalize(typed);

      var allowed = ALLOWED_NAMES.some(function (n) {
        return normalize(n) === typedNorm;
      });

      if (!allowed) {
        setHint("Sorry — your name isn’t on the list.");
        input.select();
        return;
      }

      // ✅ Format name to title case before saving
      var formatted =
        typed.charAt(0).toUpperCase() +
        typed.slice(1).toLowerCase();

      // ✅ Save the formatted name + show it on the site
      try {
        localStorage.setItem(NAME_KEY, formatted);
      } catch (e) {}

      showWelcomeBanner(formatted);

      setHint("");
      hideGate();
    });
  });

})();